import styled from 'styled-components';
import { colors } from '~/styles/colors';
import { DetailsButton } from '../../../styles';

export const ConstructionAreaInfoContainer = styled.div`
  flex: 1;

  &, & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  svg {
    width: 124px;
    height: 124px;
  }

  h4, span {
    margin: 0;
  }

  h4 {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.text['main-900']};
    text-align: center;
  }

  span {
    font-size: 11px;
    font-weight: 400;
    color: ${colors.text['sub-500']};
    text-align: center;
    margin: 0 80px;
  }
`;

export const AddConstructionButton = styled(DetailsButton)`
  // margin-top: auto;
  width: auto;
`;
